var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart101-template',{attrs:{"board-ids":[965],"data-type":_vm.dataType,"graph-id":101,"depth":_vm.depth,"date-field":"$.body.stdInfo.date","count-fields":['body.위험성평가표[*].예상재해형태_내용'],"is-move-detail":false,"title":"위험성평가 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }